import styled from 'styled-components';
import { neutral200, primary200, primary800 } from '../themes/colors';

export const StyledUpgradePagesTile = styled.div<{
  $isFullWidth?: boolean,
  $canHover?: boolean,
  $isHorizontal?: boolean,
}>`
  color: ${primary800};
  font-family: ${props => props.theme.font};

  display: flex;
  flex-direction: ${({ $isHorizontal }) => $isHorizontal ? 'row' : 'column'};
  gap: 8px;
  width: ${({ $isFullWidth }) => $isFullWidth ? '100%' : '320px'};
  border: 1px solid ${neutral200};
  padding: 20px;
  border-radius: 2px;
  transition: box-shadow 0.3s ease;
  &:hover {
    box-shadow: ${props => props.$canHover ? props.theme.upgradePages.boxShadow : 'none'};
  }
  &:focus-within {
    box-shadow: ${props => props.$canHover ? props.theme.upgradePages.focus.shadow : 'none'};
  }
`;

export const IconWrapper = styled.div<{
  $isHorizontal?: boolean,
}>`
  display: ${({ $isHorizontal }) => $isHorizontal ? 'flex' : 'block'};
  align-items: ${({ $isHorizontal }) => $isHorizontal ? 'center' : 'flex-start'};

  span {
    height: ${({ $isHorizontal }) => $isHorizontal ? '60px' : '50px'};
    width: 50px;
    display: flex;
    align-items: center;
    &:before {
      font-size: ${({ $isHorizontal }) => $isHorizontal ? '40px' : '50px'};
    }
  }
`;

export const TileTitle = styled.h5`
  font-family: ${props => props.theme.font};

  color: ${primary800};
  margin: 0;
`;

export const TileDescription = styled.p`
  font-family: ${props => props.theme.font};

  color: ${primary200};
  margin: 0;
`;

export const ContentWrapper = styled.div<{
  $isHorizontal?: boolean,
}>`
  display: flex;
  flex-direction: column;
  margin: ${({ $isHorizontal }) => $isHorizontal ? 'auto 0px' : '0px'};
  gap: ${({ $isHorizontal }) => $isHorizontal ? '0px' : '8px'};
`;
